<template>
    <div class="card flex justify-start">
    <Drawer v-model:visible="visible" header="Drawer">
            <nav @click="visible = false">
                <div v-if="usertype === 'guest'">
                    <router-link to="/">Home</router-link> <br>
                    <router-link to="/about">About</router-link> <br>
                    <router-link to="/login">Login</router-link> <br>
                    <router-link to="/register">Register</router-link> <br>
                </div>

                <div v-if="usertype === 'user' || usertype === 'admin'">
                    <router-link to="/product">Product</router-link> <br>
                    <router-link to="/cart">Cart</router-link> <br>
                    <router-link to="/userorder">User Order</router-link> <br>
                    
                </div>

                <div v-if= "usertype === 'admin'">
                    <router-link to="/chart">Chart</router-link> <br>
                    <router-link to="/ProductMgmt">Product Management</router-link> <br>
                </div>

                <div v-if="usertype === 'user' || usertype === 'admin'">
                    <button @click="logout" class="mt-4 p-1 bg-green-500 text-white rounded cursor-pointer">Logout</button>
                </div>

            </nav>
        </Drawer>
    <Button icon="pi pi-bars" @click="visible = true" class="!bg-white !text-black !border-2 !border-black hover:!bg-gray-100" />
    </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import Button from "primevue/button";
import Drawer from "primevue/drawer";
//import { jwtDecode } from "jwt-decode";
import { useUserLoginStore } from '../store/Storelogin';
import { useRouter, useRoute } from 'vue-router';

//const usertype = ref(''); // Vue 3 的響應式變數標準寫法
const router = useRouter();
const visible = ref(false);
const store = useUserLoginStore();
const route = useRoute();
const usertype = computed(() => store.storeUsertype || 'guest');

const getUserType= () => {
        const userType = store.storeUsertype;
        console.log('50');
        console.log(userType);
       
        if (!userType) {
            console.log('找不到 RefreshToken，使用者可能未登入');
            usertype.value = 'guest';
            return;
        }
        try {
            usertype.value = userType;
            console.log('目前的用戶權限是：', usertype.value);
            
        } catch (error) {
            console.error('Token 解析失敗，可能格式不正確：', error);
        }

        //const usertype = jwtDecode(gettoken);
        //console.log(usertype);
    };

const logout= () =>
    {
        console.log('執行登出動作');
        store.logout();
        usertype.value = 'guest'; // 登出後狀態切回 guest
        router.push('/login'); // 自動導回登入頁
    };
watch(
    () => route.path,
    () => {
        console.log('路由發生變化，重新獲取權限狀態');
        getUserType();
    }
);
onMounted(() => {
    getUserType();
    //logout();
});

</script>